module.exports = __webpack_public_path__ + "static/img/nume__ro-4.cdd493e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nume__ro-4.jpg
// module id = KDEB
// module chunks = 0